import React, { memo } from 'react'
import { Grid } from '@mui/material'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'

import PageContainer from '../shared/PageContainer/PageContainer'
import DisplayAlerts from '../setup/common/DisplayAlerts'
import BaseCard from '../shared/BaseCard/BaseCard'
import PanelHeading from '../shared/PanelHeading/PanelHeading'
import CustomButton from '../shared/buttons/CustomButton'
import FaIcon from '../shared/FaIcon/FaIcon'
import { LABEL_TEXT } from '../../constants/messages'
import Dropdown from '../shared/inputs/Dropdown'
import { QUEST_LIST_PROFILE_DISPATCH } from '../../store/reducers/quest/questList'
import CardGrid from '../shared/containers/CardGrid'
import ButtonsGroup from '../shared/buttons/ButtonsGroup'
import {
  buildQuestSortingOptions,
  buildQuestStatusOptions
} from '../../util/quest.helpers'
import QuestsData from './QuestsData'
import SetupRequiredAction from '../shared/Dashboard/SetupRequiredAction'
import DefaultText from '../shared/text/DefaultText'
import { SETUP_URL } from '../../constants/navigation'

const Quests = ({
  isDashboardSetupReady,
  tokenProfile,
  onCreateNew,
  dispatchAction,
  questListProfile,
  questTableProps,
  isFullIntegration,
  t
}) => {
  const title = t('quest.quests-management')
  const { status, sorting, selected, isListUpdate } = questListProfile
  return (
    <PageContainer title={title}>
      <DisplayAlerts
        isDashboardSetupReady={isDashboardSetupReady}
        tokenStatus={tokenProfile.status}
        t={t}
      />
      <CardGrid>
        <Grid item xs={12}>
          <BaseCard>
            <PanelHeading title={title}>
              {!isDashboardSetupReady ? (
                <SetupRequiredAction
                  description={t('common.not-completed-setup')}
                  t={t}
                  action={
                    <Link to={SETUP_URL}>
                      <CustomButton
                        fullWidth={false}
                        label={t('developers.start-setup')}
                      />
                    </Link>
                  }
                />
              ) : isFullIntegration ? (
                <>
                  <DefaultText label={t('quest.quests-management-desc')} />
                  <Grid
                    container
                    sx={{ display: 'flex', alignItems: 'flex-end' }}
                  >
                    <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                      <Grid item xs={12} md={4} sx={{ pr: 2 }}>
                        <Dropdown
                          id={QUEST_LIST_PROFILE_DISPATCH.SORTING}
                          label={t(LABEL_TEXT.SORTING)}
                          options={buildQuestSortingOptions(t)}
                          onChange={({ target }) =>
                            dispatchAction(
                              QUEST_LIST_PROFILE_DISPATCH.SORTING,
                              target.value
                            )
                          }
                          value={sorting}
                          size='small'
                        />
                      </Grid>
                      <Grid item xs={12} md={4} sx={{ pr: 2 }}>
                        <Dropdown
                          id={QUEST_LIST_PROFILE_DISPATCH.STATUS}
                          label={t(LABEL_TEXT.STATUS)}
                          options={buildQuestStatusOptions(t)}
                          onChange={({ target }) =>
                            dispatchAction(
                              QUEST_LIST_PROFILE_DISPATCH.STATUS,
                              target.value
                            )
                          }
                          value={status}
                          size='small'
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ButtonsGroup>
                        <CustomButton
                          fullWidth={false}
                          label={t('quest.create-new-quest')}
                          startIcon={<FaIcon icon={faPlus} />}
                          onClick={onCreateNew}
                        />
                      </ButtonsGroup>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <DefaultText
                  label={t('analytics.not-accessible-to-light-integrations')}
                />
              )}
            </PanelHeading>
          </BaseCard>
        </Grid>
        {isDashboardSetupReady && isFullIntegration && (
          <Grid item xs={12}>
            <QuestsData
              t={t}
              tokenProfile={tokenProfile}
              selected={selected}
              isListUpdate={isListUpdate}
              questListProfile={questListProfile}
              {...questTableProps}
            />
          </Grid>
        )}
      </CardGrid>
    </PageContainer>
  )
}

export default memo(Quests)
